import produce from 'immer'

import { CustomAudience } from 'api/customAudiences/types'

export interface CustomAudiencesReducer {
  audiences: CustomAudience[]
  selectedAudienceId: number | undefined
  loading: boolean
}

export const INITIAL_STATE: CustomAudiencesReducer = {
  audiences: [],
  selectedAudienceId: undefined,
  loading: true,
}

export type CustomAudiencesActions =
  | {
      type: 'SELECT_AUDIENCE'
      payload: number
    }
  | {
      type: 'REPLACE_AUDIENCES'
      payload: CustomAudience[]
    }
  | {
      type: 'UPDATE_AUDIENCE'
      payload: CustomAudience
    }
  | {
      type: 'ADD_AUDIENCE'
      payload: CustomAudience
    }
  | {
      type: 'REMOVE_AUDIENCE'
      payload: CustomAudience
    }
  | {
      type: 'SET_LOADING'
      payload: boolean
    }

const customAudiencesReducer = (
  state: CustomAudiencesReducer,
  action: CustomAudiencesActions
): CustomAudiencesReducer =>
  produce(state, (draft) => {
    switch (action.type) {
      case 'SELECT_AUDIENCE': {
        draft.selectedAudienceId = action.payload
        break
      }
      case 'REPLACE_AUDIENCES': {
        draft.audiences = action.payload
        break
      }
      case 'ADD_AUDIENCE': {
        draft.audiences.push(action.payload)
        break
      }
      case 'REMOVE_AUDIENCE': {
        const indexToRemove = draft.audiences.findIndex(
          (audience) => audience.id === action.payload.id
        )
        if (~indexToRemove) {
          draft.audiences.splice(indexToRemove, 1)
        }
        break
      }
      case 'UPDATE_AUDIENCE': {
        const indexToUpdate = draft.audiences.findIndex(
          (audience) => audience.id === action.payload.id
        )
        if (~indexToUpdate) {
          draft.audiences[indexToUpdate] = action.payload
        }
        break
      }
      case 'SET_LOADING': {
        draft.loading = action.payload
        break
      }
      default: {
        return state
      }
    }
  })

export default customAudiencesReducer
